import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import Popup from 'reactjs-popup'

import config from 'config'
import Icon from 'srcReact/components/icons/Icon'
import history from 'srcReact/helpers/history'

import { profileActions } from '../../../../../../action'
import SocialLinks from '../../../../../SocialLinks'
import ProfilePopup from '../ProfilePopup'
import styles from './styles.module.scss'
import { getDescryptedMedia, isMobileScreen } from 'srcReact/helpers/utils'
import Avatar from 'srcReact/components/common2/Avatar'
import IconButton from 'srcReact/components/common2/IconButton'
import UpdatePictureModal from '../UpdatePictureModal'
import Button from 'srcReact/components/common2/Button'
import BackNavigation from 'srcReact/components/common2/BackNavigation'

export default function ProfileHead() {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const { profileData, profilePopup } = useSelector((state) => state.myProfile)

  const {
    common: { isNative },
    login: { user: loggedInUser }
  } = useSelector((state) => state)

  const [pronoun, setPronoun] = useState('')
  const [isNestedModalOpen, setIsNestedModalOpen] = useState(false)
  const [decryptedCoverImage, setDecryptedCoverImage] = useState('')
  const [isPictureModalOpen, setIsPictureModalOpen] = useState(false)
  const [pictureModalType, setPictureModalType] = useState('')

  const editProfile = () => {
    dispatch(profileActions.setProfilePopup(true))
    dispatch(profileActions.setInitial())
  }

  useEffect(() => {
    assignPronoun()
    if (profileData?.user) {
      if (profileData.user.cover_picture) {
        const { path, is_original, original_tag, mime_type } = profileData.user.cover_picture
        getDescryptedMedia(path, is_original, original_tag, mime_type, profileData.user.id, true).then((data) => {
          setDecryptedCoverImage(data.img)
        })
      } else {
        setDecryptedCoverImage('')
      }
    }
  }, [profileData, profileData?.user?.profile_picture_data, profileData?.user?.cover_picture])

  const openPictureModal = (type) => {
    setIsPictureModalOpen(true)
    setPictureModalType(type)
  }

  const closePictureModal = () => {
    setIsPictureModalOpen(false)
    setPictureModalType('')
  }

  const assignPronoun = () => {
    if (profileData.user.preferred_pronoun === 'he') {
      setPronoun(t('my_profile.pronoun.he_him'))
    } else if (profileData.user.preferred_pronoun === 'she') {
      setPronoun(t('my_profile.pronoun.she_her'))
    } else if (profileData.user.preferred_pronoun === 'they') {
      setPronoun(t('my_profile.pronoun.they_them'))
    } else if (profileData.user.preferred_pronoun === null) {
      setPronoun('')
    }
  }

  const handleGoBack = () => {
    // nativeapp
    if (isNative) {
      window.location = config.webUrl + '?goBack=true'
      return
    }
    history.goBack()
  }

  return (
    <div className={`${styles.headContainer}`}>
      <div className={`${styles.backBtnWrapper} ${isNative && styles.isNative}`}>
        {isMobileScreen() && (
          <button className={`${styles.edit}`} onClick={editProfile}>
            {t('my_profile.info_block_edit.edit_btn')}
          </button>
        )}
        <BackNavigation customHandleBack={handleGoBack} />
      </div>
      {/* <CTAMyProfile origin='my_profile' className={styles.ctaWrapper} /> */}
      <div
        className={`${styles.backgroundBlock}`}
        style={
          decryptedCoverImage
            ? {
                backgroundImage: `url(${decryptedCoverImage})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: 'center'
              }
            : {}
        }>
        <div className={`${styles.profileImage}`}>
          <Avatar
            userId={loggedInUser.id}
            firstname={loggedInUser.firstname}
            lastname={loggedInUser.lastname}
            profilePicture={loggedInUser.profile_picture}
            rounded
            mimeType={loggedInUser.mime_type}
            originalTag={loggedInUser.original_tag}
            isOriginal={loggedInUser.is_original}
            imgWrapperSize='large100'
          />
          <IconButton
            iconName='edit'
            iconSize='large24'
            className={styles.btnEditPic}
            onClick={() => openPictureModal('avatar')}
          />
        </div>
        {!isMobileScreen() && (
          <button className={`${styles.edit}`} onClick={editProfile}>
            {t('my_profile.info_block_edit.edit_btn')}
          </button>
        )}

        <Button
          iconPosition='start'
          icon={<Icon name='edit' size='large24' />}
          text={isMobileScreen() ? t('global.edit') : t('my_profile.popup.change_cover')}
          customStyle={styles.btnEditCoverPic}
          handleClick={() => openPictureModal('cover')}
        />
      </div>
      <h2 className={`${styles.profileName}`}>
        {profileData.user.first_name} {profileData.user.last_name}
      </h2>
      {profileData.user.is_display_pronoun === '1' ? (
        <h2 className={`${styles.profileRole}`}>
          {pronoun} {profileData.user.current_occupation ? '|' : ''}{' '}
          {profileData.user.current_occupation.charAt(0).toUpperCase() + profileData.user.current_occupation.slice(1)}
        </h2>
      ) : (
        <h2 className={`${styles.profileRole}`}>
          {profileData.user.current_occupation.charAt(0).toUpperCase() + profileData.user.current_occupation.slice(1)}
        </h2>
      )}
      <SocialLinks
        messenger={profileData.editable === 1 ? false : true}
        linkedin={profileData.user.linkedIn_url ? true : false}
        instagram={profileData.user.instagram_url ? true : false}
      />
      <Popup
        open={profilePopup}
        onClose={() => dispatch(profileActions.setProfilePopup(false))}
        modal
        closeOnDocumentClick={isNestedModalOpen ? false : true}
        overlayStyle={{ background: 'rgba(54, 73, 88, 0.4)' }}
        contentStyle={{
          width: 'fit-content',
          padding: '0px',
          borderRadius: '22px',
          boxShadow: '5px 2px 10px 0 rgba(14, 11, 40, 0.15)',
          background: 'white',
          border: 'none'
        }}>
        <ProfilePopup
          setIsNestedModalOpen={setIsNestedModalOpen}
          // decryptedImage={loggedInUser.profile_picture}
          // decryptedCoverImage={decryptedCoverImage}
          isNative={isNative}
        />
      </Popup>
      {isPictureModalOpen && pictureModalType && (
        <UpdatePictureModal
          isOpen={isPictureModalOpen}
          type={pictureModalType}
          decryptedCoverImage={decryptedCoverImage}
          closeModal={closePictureModal}
        />
      )}
    </div>
  )
}
